import { recommendationAdapter } from './slices';
import { selectBlockById } from '../farm/selectors';
import { selectLoadingState } from '../helpers';

// This will be removed/uncommented in future
// const selectRecommendationState = (state) => state.recommendationData.recommendation;

const selectRecommendationState = (state) => {
  const recommendationObj = { ...state.recommendationData.recommendation };
  recommendationObj.ids = recommendationObj.ids.filter((d) => !d.includes('undefined'));
  return recommendationObj;
};

const recommendationSelectors = recommendationAdapter.getSelectors(selectRecommendationState);

const selectRecommendationIdentifierForBlock = (state, blockId) => {
  const recommendationsIdentifier = recommendationSelectors.selectAll(state)
    .filter((d) => Number(blockId) === d.block)
    .map((d) => `${d.block}-${d.type}${d.type === 'imagery_anomaly' ? `-${d.anomalyType}` : ''}`);

  return recommendationsIdentifier;
};

const selectRecommendationForBlock = (state, blockId) => {
  const recommendationsIdentifier = selectRecommendationIdentifierForBlock(state, blockId);
  const recommendationObj = recommendationsIdentifier.map((identifier) => {
    const recommendation = recommendationSelectors.selectById(state, identifier);
    if (!recommendation) return undefined;
    const block = selectBlockById(state, recommendation.block);
    return {
      ...recommendation,
      blockName: block && block.name,
    };
  });
  return recommendationObj;
};

const selectRecommendationsForBlocks = (state, blockIds) => (
  blockIds.reduce((result, blockId) => {
    const recommendation = selectRecommendationForBlock(state, blockId);
    if (recommendation && recommendation.length) {
      result.push(...recommendation);
    }
    return result;
  }, [])
);

const selectRecommendations = recommendationSelectors.selectAll;

const selectLoadingRecommendations = (state) => (
  selectLoadingState(selectRecommendationState(state)));

export {
  selectRecommendationForBlock,
  selectRecommendationsForBlocks,
  selectRecommendations,
  selectLoadingRecommendations,
};
